import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/fleet/vehicle-groups')({
  component: lazyRouteComponent(() => import('&/features/settings/fleet/pages/vehicle-groups-page')),
  staticData: { titleKey: 'vehicleGroups' },
});
